import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function Introduction() {
    return (
        <OnboardingBody title='WhatsApp + Nutshell'>
            <div className='mt-16'>
                <BulletedList
                    bullets={[
                        'Connect your WhatsApp Business account to send and receive WhatsApp messages via the Nutshell inbox.',
                        'Create leads from inbound WhatsApp messages to your business.',
                    ]}
                />
            </div>
        </OnboardingBody>
    );
}
